import React from 'react';
import {connect} from 'react-redux'

import {get as _get} from "lodash";
import * as actions from '../../../store/actions'


import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import BaseHomePageLogoWrapper from "../../theme/logoCards/baseHomePageLogoWrapper"

import {isUserLoggedIn} from "../../../utils/session/logout";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import BaseModal from "../../theme/modals/BaseModal";
import MapFrame from "../../theme/maps/mapFrame";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
import {getSubdomain} from "../../../utils/general"
import {projectStartSearch} from "../../../utils/projectStartSearch"

class HomePage extends React.Component {


    constructor(props) {
        super(props);

        let randomBGInt = () => {
            let r = Math.random()
            if (r < .34) {
                return 1
            } if (r < .67) {
                return 2
            } 
                return 3
            
        }

        this.state = {
            property_address_value: null,
            error: null,
            bgInt: randomBGInt(),
            displayMap: false,
            showOnlyProgramsWithFunders: true

        }

        // working default
        this.defaultGeojson = {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "feature",
                    "geometry": {
                        "type": "MultiPolygon",
                        "coordinates": [
                        ]
                    }
                }
            ]
        }

        this.mapGeojson = this.defaultGeojson;

    }


    componentDidMount() {
        toggleGlobalLoader(false);
    }

    handleAddressFormSubmit = synEvent => {
         synEvent.preventDefault();
         // this.checkProgramsForAddress();
         projectStartSearch(this.state.property_address_value, this.props.history)
    }



    loadAndOpenMap = () => {
        toggleGlobalLoader(true);

        api.get('/country-geojson/', {wfunders: this.state.showOnlyProgramsWithFunders ? 1 : null})
            .then(res => {
                this.mapGeojson = res.data;
                this.setState({displayMap: false}, () => this.setState({displayMap: true})); // off before on as security and to ensure update
            })
            .catch(err => addErrorAlert("Something's not right. We had a problem getting the map data."))
            .finally(() => toggleGlobalLoader(false))
    };

    closeAndClearMap = () => {
        this.setState({displayMap: false})
    }


    render() {

        return (
            <div id="homepage-wrapper">
                <section className="hero is-fullheight" id={'homepage-hero-' + this.state.bgInt}>
                    <PublicTopNav/>
                    <div className="hero-body" >
                        <div className="container" >
                            {/* style={{backgroundColor: "rgba(255,255,255, .5)"}} */}
                            <h2 className="subtitle has-text-primary mb-6 is-size-1 is-size-4-mobile">
                                Get instant financing options for your commercial building improvement.
                            </h2>
                            <h1 className="subtitle has-text-primary mb-5 is-size-5-mobile">
                                Let's start. What is the project address or business name and city?
                            </h1>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                                <div >
                                    <form onSubmit={this.handleAddressFormSubmit} className="is-flex is-flex-wrap-wrap">
                                            <div className="main-home-input mr-2">
                                                 <Input
                                                     type="text"
                                                     placeholder="Enter property address"
                                                     value={this.state.property_address_value}
                                                     onChange={val => this.setState({property_address_value: val, property_address_error: false})}
                                                    />
                                            </div>
                                            <div className="main-home-input">
                                                    <button type='submit' className="button is-link">
                                                         Start Your Project
                                                    </button>
                                            </div>
                                    </form>
                                </div>
                                <div className="input-error has-text-danger"
                                     style={{opacity: this.state.error ? 1 : 0}}>
                                    {this.state.error || ''}
                                </div>
                            </div>

                            <div className="listed-states low-home-page-text mt-6 is-hidden-mobile"
                                 style={{marginTop: '15vh', marginBottom: '1em'}}>

                                {/* <button className="button is-text" */}
                                {/*        onClick={this.loadAndOpenMap} */}
                                {/* > */}
                                {/*    See CleanFi's PACE Markets */}
                                {/* </button> */}
                            </div>

                            <BaseHomePageLogoWrapper/>
                        </div>
                    </div>
                    <div className="home-down-wrapper">
                        <a href="#mail-signup">
                            <i className="fas fa-arrow-circle-down"/>
                        </a>
                    </div>
                </section>


                <section className="hero has-background-link-dark" id="mail-signup">
                    <div className="hero-body">
                        <div className="cc-contact-form">
                            <div className="ctct-inline-form" data-form-id="9dccc015-3a21-41a1-9945-dfa717fed01d"/>
                        </div>
                    </div>
                </section>



                {this.state.displayMap &&
                    <BaseModal
                        visible
                        cardStyle={{width: 1040, height: 840,  display: 'flex', justifyContent: 'center'}}
                    >
                        <div className="has-background-white">
                            <MapFrame
                                geojsonData={this.mapGeojson}
                                polygonFill={this.state.showOnlyProgramsWithFunders ? '#A0DF00' : '#1C4E89'}
                            />
                            <div className="buttons are-small p-4">
                                <button className={`button ${this.state.showOnlyProgramsWithFunders ? 'is-primary' : ''}`}
                                        onClick={() => {
                                            if (this.state.showOnlyProgramsWithFunders) return;
                                            this.setState({showOnlyProgramsWithFunders: true}, this.loadAndOpenMap)
                                        }}
                                >
                                    Programs on PACEfi
                                </button>
                                <button className={`button ${this.state.showOnlyProgramsWithFunders ? '' : 'is-primary'}`}
                                        onClick={() => {
                                            if (!this.state.showOnlyProgramsWithFunders) return;
                                            this.setState({showOnlyProgramsWithFunders: false}, this.loadAndOpenMap)
                                        }}
                                >
                                    Areas with Pace Programs
                                </button>
                            </div>
                        </div>
                        <button onClick={this.closeAndClearMap} className="modal-close is-large" aria-label="close"/>
                    </BaseModal>
                }
                <PacefiFullScreenSpinner/>
            </div>

        )
    }

}


const mapStateToProps = state => ({
    subdomainInfo: state.session.subdomainInfo,
})

const mapDispatchToProps = dispatch => ({
    updateProjectInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateProjectComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),
    clearFormFlow: data => dispatch(actions.formFlow.clearFormFlow()),
    setFocusedProject: data => dispatch(actions.projectLeads.setFocusedProject()),
    updateInfoFeedDisplay: data => dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearInfoFeedDisplay: data => dispatch(actions.infoFeed.clearInfoFeedDisplay()),
})


export default connect(mapStateToProps, mapDispatchToProps)(HomePage)



